import React from 'react';
import { Search, X } from 'lucide-react';

const CATEGORIES = [
  { value: '', label: 'Sve kategorije' },
  { value: 'payment', label: 'Plaćanje' },
  { value: 'delivery', label: 'Isporuka' },
  { value: 'quality', label: 'Kvalitet' },
  { value: 'fraud', label: 'Prevara' },
  { value: 'communication', label: 'Komunikacija' },
  { value: 'other', label: 'Ostalo' },
];

const DisputeFilters = ({ search, onSearchChange, category, onCategoryChange, onClear }) => {
  const hasFilters = search || category;

  return (
    <div className="flex flex-wrap gap-3 mb-5">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e?.target?.value)}
          placeholder="Pretraži po korisniku, predmetu..."
          className="w-full pl-9 pr-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
        />
      </div>
      <select
        value={category}
        onChange={(e) => onCategoryChange(e?.target?.value)}
        className="px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white min-w-[160px]"
      >
        {CATEGORIES?.map((c) => (
          <option key={c?.value} value={c?.value}>{c?.label}</option>
        ))}
      </select>
      {hasFilters && (
        <button
          onClick={onClear}
          className="flex items-center gap-1.5 px-3 py-2.5 text-sm text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-100 transition-colors bg-white"
        >
          <X className="w-4 h-4" />
          Obriši filtere
        </button>
      )}
    </div>
  );
};

export default DisputeFilters;
